//#region Libraries
import { useNavigate } from "react-router-dom";
//#endregion
//#region Styles
import { Row } from "components/styles";
//#endregion
//#region Components
import CustomButton from "components/CustomButton/CustomButton";
import CustomDatePicker from "components/CustomDatePicker/CustomDatePicker";
import CustomSelect from "components/CustomSelect/CustomSelect";
import CustomTextInput from "components/CustomTextInput/CustomTextInput";
//#endregion
//#region Images
import CalendarIcon from "icons/CalendarIcon";
import searchIcon from "img/search_icon.svg";
//#endregion
//#region Utils
import ABSOLUTE_PATHS from "routes/utils/absolutePaths";
import { getOptionsToCustomSelect } from "components/CustomSelect/utils";
//#endregion

const DEFAULT_OPTION_FOR_SELECTS = {
    value: "",
    text: "Todos"
}

const SchedulesHeader = ({
    isCoordinator,
    filters,
    options: {
        advisers
    },
    setTriggerRequest,
    isBoss
}) => {
    const {
        adviserCode, 
        date, student
    } = filters.value;
    const navigate = useNavigate();
    //#region Functions
    const changeStudentField = value => {
        filters.change("student", { ...student, field: value });
    }
    const changeDateField = value => {
        filters.change("date", value); 
        setTriggerRequest(true);
    }
    const getAdviserFieldOptionProps = () => {
        return [{ ...DEFAULT_OPTION_FOR_SELECTS }].concat(getOptionsToCustomSelect(advisers, { 
            id: "code", 
            text: "name" 
        }));
    }
    //#endregion
    return(
        <Row align="flex-end" marginTop="10px">
            <Row align="flex-end" justifyContent="flex-start">
                {isCoordinator 
                ? <CustomSelect 
                    defaultOptionText={DEFAULT_OPTION_FOR_SELECTS.text}
                    label="Busca por nombre de asesor"
                    optionsProps={getAdviserFieldOptionProps()}
                    onChange={value => filters.changeAdviserCode(value, setTriggerRequest)}
                    value={adviserCode}/>
                : <CustomTextInput 
                    placeholder="Ingresa el nombre, apellido o código UTP"
                    label="Busca un alumno"
                    width="500px"
                    iconAdornment={<img src={searchIcon}/>}
                    value={student.field}
                    onChange={changeStudentField}/>}
                <CustomDatePicker 
                    value={date}
                    onChange={changeDateField}
                    period={{
                        min: [2021, 1, 1],
                        max: [3000, 1, 1]
                    }}
                    label="Buscar por fecha"
                    placeholder="Selecciona una fecha"
                />
                <CustomButton 
                    disabled= {filters.isCleared()}
                    onClick={filters.clear}
                    variant="secondary"
                    size="medium"
                    text="Limpiar"/>
            </Row>
            {!isBoss && isCoordinator && 
            <CustomButton
                icon={<CalendarIcon />} 
                variant="primary"
                size="medium"
                text="Crear asesoría"
                onClick={()=> navigate(ABSOLUTE_PATHS.APPOINTMENT_EMPLEABILIDAD_CREATE)}/>}
        </Row>
    );
}

export default SchedulesHeader;